import UnstyledButton from '../../UnstyledButton';

import { ReactComponent as CrossCircleFilledSvg } from '@frontend/icons/cross-circle-filled.svg';
import Icon from '../../Icon';

interface BottomSheetCloseButtonProps {
  className?: string;
  onClick?: () => void;
  dataTestId?: string;
}

export default function CloseButton({
  className,
  dataTestId,
  onClick,
}: BottomSheetCloseButtonProps) {
  return (
    <UnstyledButton
      className={className}
      onClick={onClick}
      data-test-id={dataTestId}
      aria-label="Close"
    >
      <Icon
        component={<CrossCircleFilledSvg />}
        color="neutral-400"
        size="24"
      />
    </UnstyledButton>
  );
}
